import { useState, useCallback } from 'react';

export const useToasts = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, duration) => {
    const id = new Date().getTime();
    setToasts(prevToasts => [...prevToasts, { id, message, duration }]);
  }, []);

  const hideToast = useCallback(id => {
    setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id));
  }, []);

  return { toasts, showToast, hideToast };
};
